import { getHistoryUrlParams } from '@/store/gamestate/gamestate'

// TODO refactor this for custom spot flop preflop only - now its together
// review this shortcuts sol lib vs cussol
// too much logic here too many cases - refactor
function getSetupParams({
  namespace,
  rootGetters,
  last_hand_query,

  query_board,
  query_board_filter,
  query_fullhand_setup,
  gameformat,
  query_gameformat,
  history_spot,
  history_spots,
  gmfs_tableConf,
  gmfs_tableRows,
  session_uid,

  solution_type,
  custree_id,
  solElite = null,
  availableShortcuts,
}) {
  query_board = query_board || rootGetters[`${namespace}/query_board`]
  query_board_filter = query_board_filter || rootGetters[`${namespace}/query_board_filter`]
  query_fullhand_setup = query_fullhand_setup || rootGetters[`${namespace}/query_fullhand_setup`]
  gameformat = gameformat || rootGetters[`${namespace}/gameformat`]
  query_gameformat = query_gameformat || rootGetters[`${namespace}/query_gameformat`]
  history_spot = history_spot || rootGetters[`${namespace}/history_spot`]
  history_spots = history_spots || rootGetters[`${namespace}/history_spots`]
  history_spots = history_spots.filter(e => e.id < history_spot?.id)

  solElite = rootGetters ? rootGetters[`${namespace}/sol_elite`] : solElite
  custree_id = custree_id || solElite?.cTree ? solElite.custom_tree_id : null
  solution_type = solution_type || (solElite?.want_use && solElite?.cTree) ? 'custom' : 'gwiz'

  const customSolutionType = solution_type === 'custom'

  let historyParams = getHistoryUrlParams({ history_spots })
  const q = query_fullhand_setup

  const qq = {}
  Object.keys(q).forEach(key => {
    qq[key] = q[key].split(',').filter(i => i)
  })

  let starting_street = null
  let shortcut_names = null
  let hero_positions = null
  let opponent_positions = null
  let relative_hero_position = null

  let heros = qq.fh_hero
  let opponents = qq.fh_opponent
  let ipOpp = qq.fh_rel_positions

  if (customSolutionType) {
    if (q.fh_start_spot === 'custom_spot') {
      hero_positions = history_spot?.position
    } else {
      // -----11 refactor
      const ls = last_hand_query || {}

      if (q.fh_alternate) {
        const lastHeros = ls.fh_hero_tmp ? ls.fh_hero_tmp.split(',').filter(i => i) : []
        const lastOpponents = ls.fh_opponent_tmp ? ls.fh_opponent_tmp.split(',').filter(i => i) : []
        if (
          heros.some(h => lastHeros.includes(h)) ||
          opponents.some(o => lastOpponents.includes(o))
        ) {
          heros = qq.fh_opponent
          opponents = qq.fh_hero
        }
      }

      if (ipOpp.length > 1) {
        const lastIpOop = ls.fh_rel_position_tmp
        ipOpp = ipOpp.filter(a => a !== lastIpOop)
      }
      // debugger
      // -----11 refactor
      // starting_street = solElite.cTree.starting_street
    }
  } else if (q.fh_start_spot === 'custom_spot') {
    hero_positions = history_spot?.position
  } else {
    // -----11 refactor
    const ls = last_hand_query || {}

    if (q.fh_alternate) {
      const lastHeros = ls.fh_hero_tmp ? ls.fh_hero_tmp.split(',').filter(i => i) : []
      const lastOpponents = ls.fh_opponent_tmp ? ls.fh_opponent_tmp.split(',').filter(i => i) : []
      if (
        heros.some(h => lastHeros.includes(h)) ||
        opponents.some(o => lastOpponents.includes(o))
      ) {
        heros = qq.fh_opponent
        opponents = qq.fh_hero
      }
    }

    if (ipOpp.length > 1) {
      const lastIpOop = ls.fh_rel_position_tmp
      ipOpp = ipOpp.filter(a => a !== lastIpOop)
    }
    // -----11 refactor

    starting_street = q.fh_start_spot.toUpperCase()
    shortcut_names = qq.fh_actions
  }

  relative_hero_position = ipOpp[0]
  hero_positions = [heros].flat()
  opponent_positions = [opponents].flat()

  // shortcut_names and starting_street are tied to shortcuts, and if there are no shortcuts, BE returns 400
  const streetShortcuts = (availableShortcuts || []).filter(i => i.street === starting_street)
  const street_params = {
    ...(streetShortcuts.length && starting_street ? { starting_street } : {}),
    ...(streetShortcuts.length && shortcut_names ? { shortcut_names } : {}),
    ...(hero_positions ? { hero_positions } : {}),
    ...(opponent_positions ? { opponent_positions } : {}),
    ...(relative_hero_position ? { relative_hero_position } : {}),
  }

  const { gametype } = query_gameformat

  let depth = null
  let stacks = null
  let depth_list = null
  let stacks_list = null
  let average_stack = null
  let gametype_list = null

  if (!customSolutionType && q.fh_start_spot === 'custom_spot') {
    depth = query_gameformat.depth
    stacks = query_gameformat.stacks
  } else {
    gmfs_tableConf = gmfs_tableConf || rootGetters[`${namespace}/gmfs_tableConf`]
    const { depthRow, stacksRow, avgStackRow } = gmfs_tableConf

    depth_list = depthRow
      ? query_gameformat.depth_list
          ?.split(',')
          .filter(i => i)
          .map(i => Number(i))
      : []
    average_stack = avgStackRow
      ? query_gameformat.average_stack
          ?.split(',')
          .filter(i => i)
          .map(i => Number(i))
      : []
    stacks_list = stacksRow ? query_gameformat.stacks_list?.split(',').filter(i => i) : []

    const allAny = !depth_list?.length && !average_stack?.length && !stacks_list?.length

    gmfs_tableRows = gmfs_tableRows || rootGetters[`${namespace}/gmfs_tableRows`]
    if (allAny) {
      const list = gmfs_tableRows.map(i => i?.row_id)
      if (depthRow) {
        depth_list = list.map(i => Number(i))
      } else if (avgStackRow) {
        average_stack = list.map(i => Number(i))
      } else {
        stacks_list = list
      }
    }

    const selectedRows = allAny ? gmfs_tableRows : gmfs_tableRows.filter(i => i.selected)

    gametype_list = selectedRows.reduce(
      (a, b) => [
        ...a,
        ...(b.gameformats ? b.gameformats.map(i => i.gametype) : [b.gametype]), // cash table rows are just gameformats
      ],
      [],
    )
    gametype_list = [...new Set(gametype_list)]
  }

  const gmf_params = customSolutionType // for now
    ? {
        ...(custree_id ? { custom_tree_id: custree_id } : {}),
      }
    : {
        ...(!gametype_list?.length ? { gametype } : {}),
        ...(gametype_list?.length ? { gametype_list } : {}),

        ...(depth_list?.length || !depth ? {} : { depth }),
        ...(stacks_list?.length || !stacks ? {} : { stacks }),

        ...(depth_list?.length ? { depth_list } : {}),
        ...(stacks_list?.length ? { stacks_list } : {}),
        ...(average_stack?.length ? { average_stack } : {}),
      }

  const boardFilterParams = {}
  Object.keys(query_board_filter).forEach(key => {
    if (query_board_filter[key]) {
      const opts = query_board_filter[key].split(',').filter(i => i)
      boardFilterParams[key] = key === 'flop_subset' ? Number(opts[0]) : opts
    }
  })

  const board = query_board

  const fhgs = q.fh_groups_selection
  const only_close_decisions = fhgs === 'only_cd'
  const flop_hand_categories = fhgs === 'hand_class' ? qq.fh_hands : null
  const flop_draw_categories = fhgs === 'hand_class' ? qq.fh_draws : null
  const selected_simple_hands = fhgs === 'manual' ? qq.fh_groups : null

  const rng = query_fullhand_setup.fh_rng || 'off'
  const hero_stack_type =
    gameformat.format !== 'chipev' && gameformat.group === 'mtt' && q.fh_hero_stack_type
      ? qq.fh_hero_stack_type
      : null

  if (!historyParams?.preflop_actions && !historyParams?.flop_actions) {
    historyParams = {}
  }

  const params = {
    session: session_uid || rootGetters.session_uid,
    ...street_params,
    ...gmf_params,
    ...boardFilterParams,
    ...(board ? { board } : {}),
    ...(rng ? { rng } : {}),

    ...(selected_simple_hands ? { selected_simple_hands } : {}),
    ...(only_close_decisions ? { only_close_decisions } : {}),
    ...(flop_hand_categories ? { flop_hand_categories } : {}),
    ...(flop_draw_categories ? { flop_draw_categories } : {}),

    ...(hero_stack_type ? { hero_stack_type } : {}),
    ...(historyParams || {}),
  }
  // console.log(gmf_params)
  // console.log(params)
  // console.log(q)
  // debugger
  return params
}

export { getSetupParams }
